"use client";

import { AlertTriangle, ExternalLink, Wrench, X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/modal";
import { ForumRichContent } from "@/features/forum/components/forum-rich-editor";
import { getRuntimeState, type RuntimeState } from "./system-api";
import { formatDateTime } from "./system-runtime-client";

export function PublicMaintenanceBanner() {
  const [runtime, setRuntime] = useState<RuntimeState | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    void getRuntimeState().then(setRuntime).catch(() => undefined);
  }, []);

  const announcement = runtime?.publicAnnouncement;
  if (!announcement) return null;
  const active = runtime.maintenanceActive;

  return (
    <>
      <div className="fixed inset-x-4 top-4 z-40 mx-auto flex max-w-3xl items-center gap-3 rounded-lg border border-amber-300 bg-white/95 px-4 py-3 text-sm text-[#07162D] shadow-lg backdrop-blur dark:border-amber-700 dark:bg-slate-950/95 dark:text-white">
        {active ? <AlertTriangle className="h-5 w-5 shrink-0 text-red-600" /> : <Wrench className="h-5 w-5 shrink-0 text-amber-600" />}
        <div className="min-w-0 flex-1">
          <p className="font-semibold">{active ? "Sistema em manutenção" : "Manutenção programada"}</p>
          <p className="truncate text-xs text-slate-600 dark:text-slate-300">{announcement.title} · {formatDateTime(runtime.startsAt)} a {formatDateTime(runtime.endsAt)} · Horário de Brasília</p>
        </div>
        <button className="rounded-md border border-slate-200 px-3 py-1.5 text-xs font-semibold hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-900" onClick={() => setOpen(true)} type="button">Ver aviso</button>
      </div>
      <Modal open={open} title={announcement.title} description={`Publicado em ${formatDateTime(announcement.publishAt)}`} onClose={() => setOpen(false)} size="lg" height="auto" footer={<div className="flex justify-end"><button className="inline-flex items-center gap-2 rounded-md bg-slate-950 px-4 py-2 text-sm font-semibold text-white dark:bg-white dark:text-slate-950" onClick={() => setOpen(false)} type="button"><X className="h-4 w-4" /> Fechar</button></div>}>
        <div className="space-y-4">
          <div className="rounded-md bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-950 dark:bg-amber-950/40 dark:text-amber-100">{active ? "Sistema em manutenção" : "Manutenção programada"}</div>
          <ForumRichContent className="max-w-none [&_img]:h-auto [&_img]:max-w-full" content={announcement.body} contentFormat={looksLikeRichHtml(announcement.body) ? "html" : "plain"} />
          {announcement.deepLink ? <Link className="inline-flex items-center gap-1 text-sm font-semibold text-sky-700 hover:underline" href={announcement.deepLink}><ExternalLink className="h-4 w-4" /> Abrir contexto</Link> : null}
        </div>
      </Modal>
    </>
  );
}

function looksLikeRichHtml(value: string) { return /<\/?[a-z][\s\S]*>/i.test(value); }
